import {Dispatch, SetStateAction, useEffect, useRef} from "react";

const useOutside = ({ setOpen }: { setOpen: Dispatch<SetStateAction<boolean>> }) => {
    const optionRef = useRef(null);
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (optionRef.current && !(optionRef.current as Node).contains(event.target as Node)) {
                setOpen(false)
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [optionRef]);

    return { optionRef }
}

export default useOutside;
